import { render, staticRenderFns } from "./l12install.vue?vue&type=template&id=20fd716f&scoped=true&"
import script from "./l12install.vue?vue&type=script&lang=js&"
export * from "./l12install.vue?vue&type=script&lang=js&"
import style0 from "./l12install.vue?vue&type=style&index=0&id=20fd716f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fd716f",
  null
  
)

export default component.exports